export default __webpack_public_path__ + "static/media/hr-1.5624288d.png";